const temporary = {
    state: {
        temporaryObj: ""
    },
  
    mutations: {
      SET_TEMPORARY_OBJ: (state, obj) => {
        state.temporaryObj = obj;
      }
    },
  
    actions: {}
  };
  
  export default temporary;


// WEBPACK FOOTER //
// ./src/store/modules/temporary.js